import React from "react";

// Settings chosen when a task is created and locked afterwards. They still shape how the task
// behaves, so the Settings tab shows them rather than leaving an admin guessing why the task acts
// the way it does - just with no way to change them here.
type Props = {
    items: { label: string; value: React.ReactNode }[];
};

export default function FixedSettings({ items }: Props) {
    if (items.length === 0) return null;

    return (
        <div
            data-testid="fixed-settings"
            style={{
                marginBottom: "16px",
                padding: "12px",
                border: "1px solid #e0e0e0",
                borderRadius: "4px",
                backgroundColor: "#fafafa",
            }}
        >
            <div style={{ fontWeight: 600, fontSize: "14px", marginBottom: "4px" }}>
                Fixed at creation
            </div>
            <div style={{ fontSize: "12px", color: "#6b7280", marginBottom: "12px" }}>
                Set when the task was created and cannot be changed.
            </div>

            <div style={{ display: "grid", gridTemplateColumns: "auto 1fr", gap: "8px 16px" }}>
                {items.map((item) => (
                    <React.Fragment key={item.label}>
                        <div style={{ color: "#6b7280", fontSize: "13px" }}>{item.label}</div>
                        <div data-testid={`fixed-setting-${item.label}`} style={{ fontSize: "13px" }}>
                            {item.value}
                        </div>
                    </React.Fragment>
                ))}
            </div>
        </div>
    );
}
